import {
  call,
  fork,
  put,
  takeLatest,
} from 'redux-saga/effects';
import { fetchFlags } from 'api';
import { parseError } from 'logic/helpers';
import * as actions from './actions';
import { fetchFlagsSuccess, fetchFlagsFailure } from './actionCreators';

function* fetchFlagsWorker() {
  try {
    const json = yield call(fetchFlags); // browser cache + SWR handles revalidation
    yield put(fetchFlagsSuccess(json));
  } catch (err) {
    yield put(fetchFlagsFailure(parseError(err)));
  }
}

export default [
  fork(takeLatest, actions.FETCH_FLAGS_REQUEST, fetchFlagsWorker),
];
